/* @flow */

import { DateTime, LocalZone } from 'luxon';

import { timeFormat12h } from 'src/shared/app/locale/settings/localeSettings';

export const dateFormatOpts = {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
};

export const datetimeFormatOpts = {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const monthDayFormatOpts = {
  month: 'short',
  day: 'numeric',
};

export const weekDayFormatOpts = {
  weekday: 'short',
};

export const dayFormatOpts = {
  day: 'numeric',
};

export const timeFormatOpts = {
  hour: 'numeric',
  minute: 'numeric',
};

export function formatDate(date: DateTime, locale: string): string {
  return date.setLocale(locale).toLocaleString(dateFormatOpts);
}

export function formatMonthDay(date: DateTime, locale: string): string {
  return date.setLocale(locale).toLocaleString(monthDayFormatOpts);
}

export function formatWeekDay(date: DateTime, locale: string): string {
  return date.setLocale(locale).toLocaleString(weekDayFormatOpts);
}

export function formatDay(date: DateTime, locale: string): string {
  return date.setLocale(locale).toLocaleString(dayFormatOpts);
}

export function formatDateTime(
  date: DateTime,
  locale: string,
  timeFormat: string,
  withLocalZone: boolean = false,
): string {
  return setDateTimezone(date, withLocalZone)
    .setLocale(locale)
    .toLocaleString(
      setTimeFormatOption(
        {
          ...datetimeFormatOpts,
        },
        timeFormat,
      ),
    );
}

export function formatTime(
  date: DateTime,
  locale: string,
  timeFormat?: string,
  withLocalZone: boolean = false,
) {
  return setDateTimezone(date, withLocalZone)
    .setLocale(locale)
    .toLocaleString(
      setTimeFormatOption(
        {
          ...timeFormatOpts,
        },
        timeFormat,
      ),
    );
}

export function setTimeFormatOption(opts: Object, timeFormat?: string): Object {
  if (timeFormat) {
    // $FlowIssue
    opts.hour12 = timeFormat === timeFormat12h;
  }

  return opts;
}

export function setDateTimezone(
  date: DateTime,
  withLocalZone: boolean,
): DateTime {
  if (withLocalZone) {
    const { instance: localZone } = LocalZone;

    if (localZone.isValid) {
      return date.setZone(localZone);
    }
  }

  return date;
}
